import RootState from '@/store/root_state';
import { ActionTree, Commit, Dispatch } from 'vuex';
import { UserAccountState } from './state';
import { MicroserviceEnum, query } from '@/helpers/westeros';
import {
  getTokenDInfo,
  GetTokenDInfoQueryResult,
  getUserAccounts,
  GetUserAccountsQueryResult,
} from '@/store/graphql/queries/westerosArcaneumQueries';
import accounts from '@/helpers/accountsIframe';

const actions: ActionTree<UserAccountState, RootState> = {
  async GET_USER_ACCOUNTS({ commit }): Promise<void> {
    const { data } = await query<GetUserAccountsQueryResult>(
      MicroserviceEnum.ARCANEUM,
      getUserAccounts,
    );

    const { email, provider } = data.getUserAccounts;
    commit('SET_STUDENT_EMAIL_PROVIDER', provider);
    commit('SET_STUDENT_EMAIL_HAS_ACCOUNTS', !!email && !!provider);
  },

  async GET_TOKEND_INFO({ commit }): Promise<void> {
    const payload = { tokenD: accounts.getTokenD() };

    const { data } = await query<GetTokenDInfoQueryResult>(
      MicroserviceEnum.ARCANEUM,
      getTokenDInfo,
      payload,
    );

    const { email } = data.getTokenDInfo;
    commit('SET_EMAIL_TOKEND', email);
  },
  async CHECK_AUTH_TOKEN_D({
    commit,
    dispatch,
  }: {
    commit: Commit;
    dispatch: Dispatch;
  }): Promise<void> {
    if (accounts.isLogged()) {
      await dispatch('GET_CHIMERA_FEATURE_FLAGS_INFO');
    } else {
      await commit('SET_AUTH_TOKEN', '');
      throw new Error('User is not logged');
    }
  },
};

export default actions;
